import { z } from 'zod';

export const editTeamSettingsSchema = z.object({
	invitationCode: z.string().optional(),
	isActive: z.boolean().optional().default(false),
	expirationDate: z.string().optional(),
	numberOfTimesCodeCanBeUsed: z.string().or(z.number()).optional(),
	isFreeAgent: z.boolean().optional().default(false)
});

export type EditTeamSettingsData = z.infer<typeof editTeamSettingsSchema>;
